import Navbar from "../../../component/navbar";
import Footer from "../../../component/footer";
import { useState } from "react";
import Modal from "../../../component/modal";

export default function PageHI() {
  const [titleModal, setTitleModal] = useState(
    "แบบเอกสารเคลมประกันสุขภาพกลุ่ม"
  );

  const [showModal, setShowModal] = useState(false);

  const showModalPreview = (data) => {
    setShowModal(true); // Show modal
  };

  const closeModal = () => setShowModal(false); // Close modal
  return (
    <>
      <Navbar />

      <div className="w-full h-screen relative">
        <div className="container w-full md:max-w-5xl mx-auto my-5 md:my-10 md:px-0 px-5">
          <div className="flex flex-col justify-center items-center gap-5">
            {/* Q&A */}
            <div className="text-[#9e76b4] text-xl me-auto md:me-0 md:text-5xl font-bold flex items-center gap-x-2 ml-3">
              <i className="fa fa-question-circle"></i>
              <p>ถาม-ตอบ</p>
            </div>
            <iframe
              className="md:block md:w-full h-full md:h-[600px] hidden"
              src="/AIA/File_HR/17.Q_A ประกันสุขภาพกลุ่ม AIA ปีงบประมาณ 2568.pdf"
              frameborder="0"
            ></iframe>
            <button
              onClick={() =>
                window.open(
                  "/AIA/File_HR/17.Q_A ประกันสุขภาพกลุ่ม AIA ปีงบประมาณ 2568.pdf",
                  "_blank"
                )
              }
              className="md:hidden bg-[#9e76b4] px-3 py-2 text-white w-full"
            >
              Q&A (ถาม-ตอบ)
            </button>
            {/* Q&A */}
            <div className="border-b-2 border-[#9e76b4] w-full"></div>
            {/* Menu Icon */}
            <div className="grid grid-cols-2 px-2  md:flex justify-around items-center py-5 gap-10">
              <div
                onClick={() =>
                  window.open(
                    "/AIA/ตารางการประกันชีวิต-aia-บุคลากร.jpg",
                    "_blank"
                  )
                }
                className="flex flex-col justify-center items-center gap-y-3 hover:scale-105 transition-all duration-500 cursor-pointer"
              >
                <img
                  src="https://img.icons8.com/?size=100&id=OoVnDrbsxHCh&format=png&color=000000"
                  alt=""
                />
                <p className=" text-sm md:text-xl text-[#9e76b4]">
                  แผนประกันสุขภาพกลุ่ม
                </p>
              </div>
              <div
                onClick={() =>
                  window.open(
                    "https://www.aia.co.th/th/help-support/health-services/find-a-hospital",
                    "_blank"
                  )
                }
                className="flex flex-col justify-center items-center gap-y-3 hover:scale-105 transition-all duration-500 cursor-pointer"
              >
                <img
                  src="https://img.icons8.com/?size=100&id=I9VJFD3BTr3k&format=png&color=000000"
                  alt=""
                />
                <p className=" text-sm md:text-xl text-[#9e76b4]">
                  ค้นหาโรงพยาบาลคู่สัญญาณ
                </p>
              </div>
              <div
                onClick={() =>
                  window.open(
                    "https://hr.oop.cmu.ac.th/menu/news/view-TWpRNE9RPT0-Ym1WM2N6SXdNak09",
                    "_blank"
                  )
                }
                className="flex flex-col justify-center items-center gap-y-3 hover:scale-105 transition-all duration-500 cursor-pointer"
              >
                <img
                  src="https://img.icons8.com/?size=100&id=O3Fp4LBqA2e1&format=png&color=000000"
                  alt=""
                />
                <p className=" text-sm md:text-xl text-[#9e76b4]">
                  คู่มือการใช้งาน Application AIA+
                </p>
              </div>
              <div
                onClick={() => showModalPreview()}
                className="flex flex-col justify-center items-center gap-y-3 hover:scale-105 transition-all duration-500 cursor-pointer"
              >
                <img
                  src="https://img.icons8.com/?size=100&id=44004&format=png&color=000000"
                  alt=""
                />
                <p className=" text-sm md:text-xl text-[#9e76b4]">
                  แบบเอกสารเคลมประกัน
                </p>
              </div>
            </div>
            {/* Menu Icon */}
            <div className="border-b-2 border-[#9e76b4] w-full"></div>
            {/* ข้อยกเว้น */}
            <div
              onClick={() =>
                window.open(
                  "/AIA/view-TWpRNE13PT0-Ym1WM2N6SXdNak09-scaled.jpg",
                  "_blank"
                )
              }
              className="pb-[100px] w-11/12"
            >
              <img
                src="/AIA/view-TWpRNE13PT0-Ym1WM2N6SXdNak09-scaled.jpg"
                alt=""
              />
            </div>
            {/* ข้อยกเว้น */}
          </div>
        </div>
      </div>

      <Footer />
      <Modal
        id="default-modal"
        title={titleModal}
        size="max-w-7xl"
        show={showModal}
        onClose={closeModal} // Pass onClose handler to close the modal
      >
        <div className="w-full relative overflow-y-scroll h-[600px] custom-scrollbar">
          <div className="flex flex-col justify-center items-start gap-3">
            {/* File 1 */}
            <p className=" text-sm md:text-xl text-[#9e76b4]">
              <i className="fa fa-eye mr-2"></i>
              สำหรับบุคลากรที่บรรจุใหม่
            </p>
            <div className=" items-center grid grid-cols-1 mx-auto md:mx-0 md:flex gap-4">
              <div
                onClick={() => window.open("/AIA/f-b-n.pdf", "_blank")}
                className="cursor-pointer border-2 w-72"
              >
                <img
                  className="object-cover"
                  src="https://w1.med.cmu.ac.th/personnel/files/2024/11/Screenshot-2024-11-14-1616.jpg"
                  alt=""
                />
              </div>
              <div
                onClick={() =>
                  window.open(
                    "/AIA/File_HR/ตัวอย่างการกรอกเอกสารผู้รับผลประโยชน์.pdf",
                    "_blank"
                  )
                }
                className="cursor-pointer border-2 w-72 relative"
              >
                <img
                  className=" object-cover"
                  src="/AIA/File_HR/ตัวอย่างการกรอกเอกสารผู้รับผลประโยชน์.png"
                  alt=""
                />
                <div className="absolute w-full bg-white top-28  border border-red-300">
                  <div className="flex justify-center items-center h-12">
                    <p className="text-red-500 font-bold">
                      Ex.การกรอกเอกสารแต่งตั้งผู้รับผลประโยชน์
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className="border-b-2 border-[#9e76b4] w-full"></div>
            {/* File 2 */}
            <div className="flex flex-col items-start w-full gap-3 ">
              <p className=" text-sm md:text-xl text-[#9e76b4]">
                <i className="fa fa-eye mr-2"></i>
                แบบเอกสารเคลมประกันสุขภาพกลุ่ม
              </p>
              <div className="bg-zinc-200/[0.5] text-[#9e76b4] rounded-lg p-3 w-full">
                <div className="flex flex-col gap-3">
                  <div className="font-bold text-[16px]">
                    ผู้เอาประกัน ดำเนินการกรอกเอกสารพร้อมเอกสารอื่นๆ
                    ที่เกี่ยวข้อง โดยมีรายละเอียดดังนี้
                  </div>
                  <div className="ml-3">
                    <ul className="list-decimal">
                      <li>ใบนำส่งเอกสาร กรณี OPD/IPD</li>
                      <li>ใบเสร็จค่ารักษาพยาบาลต้นฉบับ</li>
                      <li>ใบรับรองแพทย์ต้นฉบับ</li>
                      <li>ใบแสดงรายละเอียดใบเสร็จ (ถ้ามี)</li>
                      <li>
                        แบบฟอร์ม 3 แบบฟอร์มแจ้งความประสงค์ขอเอกสารคืน
                        (กรณีที่บุคลากรประสงค์ขอเอกสารคืน)
                      </li>
                    </ul>
                  </div>
                  <div className="font-bold text-[16px]">
                    นำส่งเอกสารมายังงานบริหารงานทั่วไป ชั้น 2
                    อาคารคณะสัตวแพทยศาสตร์
                  </div>
                </div>
              </div>
            </div>

            <div className="grid grid-cols-1 md:flex mx-auto items-center gap-4">
              <div
                onClick={() => window.open("/AIA/view-opd.pdf", "_blank")}
                className="cursor-pointer border-2 w-52 hover:-translate-y-2 transition duration-300"
              >
                <img
                  className="object-cover"
                  src="https://w1.med.cmu.ac.th/personnel/files/2024/11/opd-scaled.jpg"
                  alt=""
                />
              </div>
              <div
                onClick={() => window.open("/AIA/ex-opd.pdf", "_blank")}
                className="cursor-pointer border-2 w-52 hover:-translate-y-2 transition duration-300"
              >
                <img
                  className="object-cover"
                  src="https://w1.med.cmu.ac.th/personnel/files/2024/11/opd-ex-scaled.jpg"
                  alt=""
                />
              </div>
              <div
                onClick={() => window.open("/AIA/view-ipd.pdf", "_blank")}
                className="cursor-pointer border-2 w-52 hover:-translate-y-2 transition duration-300"
              >
                <img
                  className="object-cover"
                  src="https://w1.med.cmu.ac.th/personnel/files/2024/11/ipd-scaled.jpg"
                  alt=""
                />
              </div>

              <div
                onClick={() => window.open("/AIA/ex-ipd-pay.pdf", "_blank")}
                className="cursor-pointer border-2 w-52 hover:-translate-y-2 transition duration-300"
              >
                <img
                  className="object-cover"
                  src="https://w1.med.cmu.ac.th/personnel/files/2024/11/ipd-ex-scaled.jpg"
                  alt=""
                />
              </div>

              <div
                onClick={() => window.open("/AIA/view-refrom.pdf", "_blank")}
                className="cursor-pointer border-2 w-52 hover:-translate-y-2 transition duration-300"
              >
                <img
                  className="object-cover"
                  src="https://w1.med.cmu.ac.th/personnel/files/2024/11/view-TWpVMk53PT0-Ym1WM2N6SXdNak09-scaled.jpg"
                  alt=""
                />
              </div>
            </div>
          </div>
          <div></div>
        </div>
      </Modal>
    </>
  );
}
